<h3 class="mt-3">Recent Stock Logs</h3>
<div class="table-container">
  @if (recentStockLogs.data.length > 0) {
    <table mat-table matSort [dataSource]="recentStockLogs">
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let row">
          {{ row.amount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
        <td mat-cell *matCellDef="let row">
          {{ row.price | currency: 'SEK' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="rowCreatedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.rowCreatedAt | date: 'medium' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="transactionType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let row">
          {{ row.transactionType }}
        </td>
      </ng-container>

      <ng-container matColumnDef="undo">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="undoTransaction(row.transactionId)" [disabled]="isSubmitting">
            <mat-icon>undo</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns" [ngClass]="{ undone: row.undone }"></tr>
    </table>
  }
</div>
